import { render, staticRenderFns } from "./jueseguanli.vue?vue&type=template&id=2d1e6bf8"
import script from "./jueseguanli.vue?vue&type=script&lang=js"
export * from "./jueseguanli.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports